import { range } from 'lodash';

/* gets a value from a same index of an inverted range (normalizing min value if needed) */
export const getMirroredValue = ({ value, min, max, normalizeFn }) => {
  const normalizedMin = normalizeFn ? normalizeFn(min) : min;
  const normalizedMax = max + 1;

  const normalRange = range(normalizedMin, normalizedMax);
  const invertedRange = normalRange.slice().reverse();

  const index = normalRange.indexOf(value);
  return invertedRange[index];
};
